import {DataTableColumn} from "mantine-datatable";
import {UsageRecord} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {NavLink} from "react-router-dom";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<UsageRecord>[] = [
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: UsageRecord) => <NavLink
                to={`/usage-records/${item.id}`}>{formatTimestamp(item.created as string)}</NavLink>,
        },
        {
            accessor: 'username',
            title: I18n.get('User'),
            width: '1fr',
            render: (item: UsageRecord) => item.user?.name || item.username,
        },
        {
            accessor: 'action',
            title: I18n.get('Action'),
            width: '1fr',
            render: (item: UsageRecord) => item.action,
        },
        {
            accessor: 'usageType',
            title: I18n.get('UsageType'),
            width: '1fr',
            render: (item: UsageRecord) => item.usageType,
        },

    ];

    return {
        columns,
    }
}